import React, { useEffect, useState } from 'react';
import Button from '../../components/Button';
import SuluxSocial from '../../components/Social';
import Copyright from '../../components/Copyright';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const BannerSlider  = (props) => {
    //const [inProp, setInProp] = useState(false);
    const [title, setTitle] = useState("");
    const [image, setImage] = useState(undefined);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [features, setFeatures] = useState(null);
    const [price, setPrice] = useState(0);
    useEffect(()=>{
        setTitle(props.attr.title);
        setImage(props.attr.image);
        setName(props.attr.name);
        setDescription(props.attr.description);
        setFeatures(props.attr.features);
        setPrice(props.attr.price);
        //setInProp(true)
    },[props]);
    return(
       
            <TransitionGroup className="slider-container">
                 <CSSTransition key={props.attr.name} timeout={3500} classNames="slide">
                 <div className={`c-banner-wrapper  absolute inset-0 lg:flex items-center h-full `} onClick={props.onClick} >
                    <div className="w-full px-16">
                        <div className="image relative">
   
                
                            <h2 className={`slide-title font-aileron text-6xl sm:text-7xl md:text-8xl lg:text-10xl xl:text-20xl uppercase font-black top-50 absolute left-0 right-0 text-center transform -translate-y-half text-white`} >{title}</h2>
                       
                           
                                <div className="-mx-16 flex justify-center relative z-10 slide-image">
                                    
                                    <div className="w-3/4 lg:w-4/12 px-32">
                                        <img src={image} alt="Tag Heuer" className="mx-auto"/>
                                    </div>
                                </div>
                           
                        </div>
                        <div className="title hidden lg:block lg:absolute lg:left-32 lg:top-96  xl:left-144 lg:px-16 lg:w-2/12 xl:w-2/12 leading-tight overflow-hidden">
                            <h2 className="uppercase text-2xl xl:text-4xl font-bold  slide-name">{name}</h2>
                        </div>
                        <div className="text -mx-16 flex flex-col items-center justify-center lg:items-start mb-40 lg:mb-0 lg:absolute lg:left-40 xl:left-144 lg:bottom-40 lg:w-3/12">
                            <div className="overflow-hidden mb-30">
                                <p className="px-16 text-center lg:text-left lg:text-sm w-11/12 lg:w-full mx-auto  slide-description">
                                    {description}
                                </p>
                            </div>
                            <div className="px-16">
                            <Button label="Learn More"/>
                            </div>
                        </div>
                        <div className="lg:absolute lg:right-56 lg:w-3/12 xl:right-144 lg:bottom-32">
                            <div className="border-t-1 border-b-1 border-gray-400 py-12 ">
                                <div className="flex  -mx-16">
                                    {features && features.map((feature,i)=>{
                                        return (
                                            <div className="px-16 text-center flex-1">
                                                <h4 className="font-bold text-sm uppercase font-aileron">{feature.title}</h4>
                                                <div className="overflow-hidden"><p className="font-light  text-sm feature-description">{feature.description}</p></div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="hidden lg:block py-16">
                                <div className="overflow-hidden">
                                    <p className="font-bold text-lg text-right slider-price">{price}</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex py-32 pb-10 lg:px-56 justify-between lg:absolute lg:bottom-0 lg:left-0 lg:right-0 lg:hidden">
                            <div className="lg:hidden"><SuluxSocial/></div>
                            <Copyright/>
                        </div>

                    </div>
                </div>
                </CSSTransition>
            </TransitionGroup>
    )
}
export default BannerSlider;